<script>
export default {
  name: 'Welcome',
}
</script>
<template>
  <section class="card welcome-panel">
    <span class="welcome-subtitle">
      {{ $gettext('Welcome to') }}
    </span>
    <img
      class="title"
      src="@static/climateplus-logo.png"
      alt="ClimatePlus"
    >
    <div class="welcome-text">
      <div>
        <!-- eslint-disable-next-line max-len -->
        {{ $gettext("ClimatePlus is a solution for mapping climate projections over a project's area for planning, feasibility studies or climate design parameters. It provides a visualization of the evolution of climate indicators in the short, medium, and long term, compared to historical reference data.") }}
      </div>
      <div>
        <!-- eslint-disable-next-line max-len -->
        {{ $gettext("Future climate projections are presented according to scenarios of future greenhouse gas (GHG) emissions into the atmosphere as defined by the Intergovernmental Panel on Climate Change (IPCC).") }}
      </div>
      <div>
        <!-- eslint-disable-next-line max-len -->
        {{ $gettext("The climate projection data comes from reference datastores that aggregate the results of climate models selected by the IPCC.") }}
      </div>
    </div>
    <img
      class="welcome-icon"
      src="@static/climateplus-icon.png"
    >
  </section>
</template>
<style lang="scss" scoped>
.welcome-panel {
  width: 40%;
  max-width: 40%;
  height: 100%;
  padding: 40px;
  position: relative;
  overflow: auto;
}
.title {
  margin-bottom: 1rem;
  width: 80%
}
.welcome-text {
  font-size: 1.1rem;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.welcome-icon {
  position: absolute;
  width: 40%;
  z-index: 1;
  opacity: 0.6;
  right: 25px;
  bottom: 25px;
  font-size: 25rem;
}

@media (width <= 1000px) {
  .welcome {
    width: max-content;
  }
}

@media (width <= 1400px), (height <= 850px) {
  .title {
    font-size: 3rem !important;
  }
  .subtitle {
    font-size: 1.6rem;
  }
}
</style>
